import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useMutationJobDelete } from "../../actions/dashboardActions";
import { SwalAlert } from "../../components/index";
export default () => {
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [file, setFile] = useState(null);
  const [success, setsuccess] = useState(false);
  const navigate = useNavigate();
  const [loadingapi, setLoadingapi] = useState(false);
  const [loadingapplyapi, setLoadingapplyapi] = useState(false);
  const { control } = useForm();
  const user = useSelector((state) => state.app.userData.userData);
  const queryClient = useQueryClient();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const siteURL = process.env.REACT_APP_SITE_URL;
  const fetchSinglejob = async ({ queryKey }) => {
    const [, jobId] = queryKey;
    const { data } = await axios.get(`${baseURL}/api/v2/job/${jobId}`, {
      params: {
        user_id: user?.talent?.user_id,
        talent_id: user?.talent?.id,
      },
    });
    return data?.data;
  };
  const {
    data: singlejob,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ["singlejob", id],
    queryFn: fetchSinglejob,
    enabled: id !== null && id !== undefined,
  });
  const shareURL = `${siteURL}/job-details/${singlejob?.id}`;

  // Toggle the visibility
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile({
        name: selectedFile.name,
        size: (selectedFile.size / 1024).toFixed(2) + " KB",
      });
    } else {
      setFile(null);
      alert("Please upload a valid PDF file.");
    }
  };
  const clearFile = () => {
    setFile(null);
  };

  const mutationJob = useMutation({
    mutationFn: async (JobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/apply-job`,
        JobData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["singlejob"]);
      setLoadingapplyapi(false);
      setsuccess(true);
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapplyapi(false);
    },
  });

  const mutationJobDelete = useMutationJobDelete(setLoadingapi);
  const mutation = useMutation({
    mutationFn: async (savedData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/saved-jobs`,
        savedData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      setLoadingapi(false);
      SwalAlert(data?.status, data?.message, "success");
    },
    onError: (error) => {
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
      setLoadingapi(false);
    },
  });

  const handleApplyJob = (id, talentId) => {
    setLoadingapplyapi(true);
    mutationJob.mutate({
      job_id: id,
      talent_id: talentId,
    });
  };
  const handleSevedJob = (id, savedJobs) => {
    if (user?.role === "talent") {
      if (savedJobs) {
        setLoadingapi(true);
        mutationJobDelete.mutate(
          {
            job_id: id,
            user_id: user?.talent?.user_id,
          },
          {
            onSettled: () => {
              refetch();
            },
          }
        );
      } else {
        setLoadingapi(true);
        mutation.mutate(
          {
            job_id: id,
            user_id: user?.talent?.user_id,
          },
          {
            onSettled: () => {
              refetch();
            },
          }
        );
      }
    }
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading jobs: {error.message}</p>
      </div>
    );
  }
  const openSharePopup = (url) => {
    const width = 600;
    const height = 500;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    window.open(
      url,
      "_blank",
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
  };
  return {
    singlejob,
    isLoading,
    loadingapi,
    loadingapplyapi,
    isOpen,
    showForm,
    file,
    success,
    user,
    navigate,
    handleToggle,
    handleFileChange,
    clearFile,
    handleSevedJob,
    handleApplyJob,
    openSharePopup,
    setShowForm,
    shareURL,
    control,
    setsuccess,
  };
};
